module.exports = __webpack_public_path__ + "static/img-duotono@2x-abbb83f2d9b21184f2f421218f7f2325.png";